function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M35.56 72.61l60.15 28.43 60.04-28.43-60.04-28.44-60.15 28.44z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M35.56 72.61l-18.95 28.43 60.14 28.44 18.96-28.44 18.95 28.44 60.05-28.44-18.96-28.43M95.71 44.17L75.73 25.01l-58.1 27.41 17.93 20.19"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M95.32 44.17l19.98-19.16 58.1 27.41-17.94 20.19M36.08 110.52v25.37l59.63 28.44 60.26-28.76V110.2M95.71 101.04v61.67"
});

var SvgBundles = function SvgBundles(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "ICON",
    viewBox: "0 0 192 192",
    "aria-hidden": true
  }, props), _ref, _ref2, _ref3);
};

export default SvgBundles;